import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import RequireSingleCountry from 'root/RequireSingleCountry';

import { vendorsMainRoute } from '..';

const vendorCommunicationMainRoute = createRoute({
  getParentRoute: () => vendorsMainRoute,
  path: 'vendor-communication',
  component: RequireSingleCountry,
});

const vendorCommunicationRoute = createRoute({
  getParentRoute: () => vendorCommunicationMainRoute,
  path: '/',
  validateSearch: z.object({
    q: z.string().optional(),
    emailTemplateId: z.string().optional(),
    isCountryDefault: z.boolean().optional(),
    viewEmailTemplate: z.boolean().optional(),
  }).parse,
  component: lazyRouteComponent(() => import('./VendorCommunicationView')),
});

export const vendorCommunicationRouteTree = vendorCommunicationMainRoute.addChildren([
  vendorCommunicationRoute,
]);
